import { Button, Icon } from '@frontend/ui-library';

import { ReactComponent as ArrowLeftSvg } from '@frontend/icons/arrow-left.svg';

export interface BackButtonProps {
  className?: string;
  onClick?: () => void;
}

export default function BackButton({
  className,
  onClick,
}: BackButtonProps): JSX.Element {
  return (
    <Button
      data-test-id="back-button"
      aria-label="Go back"
      className={className}
      variant="white-outline"
      size="medium"
      leftIcon={<Icon component={<ArrowLeftSvg />} />}
      onClick={onClick}
    >
      Back
    </Button>
  );
}
